<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "FulfillmentOmsAccess",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  